export default __webpack_public_path__ + "static/media/bg_1.e221eab3.svg";